import Sortable from '@stimulus-components/sortable'

/**
 * Extends @stimulus-components/sortable to renumber hidden weight fields
 * after drag-and-drop reorders and after adding/removing nested form items.
 *
 * Weight fields are updated to match the current visible DOM order (0-based),
 * skipping items marked for destruction (hidden by nested-form#remove).
 * This ensures the visual order is persisted when the form is submitted.
 *
 * Usage in ERB (direct action descriptors on buttons):
 *   data-action="nested-form#add sortable-weight#renumber"
 *   data-action="nested-form#remove sortable-weight#renumber"
 *
 * Each nested form item must include a hidden `input[name*="[weight]"]` field.
 */
export default class extends Sortable {
  /** @returns {object} SortableJS options with onEnd callback for weight renumbering */
  get options() {
    return {
      ...super.options,
      onEnd: this.renumber.bind(this),
    }
  }

  /**
   * Sets each visible nested form wrapper's `input[name*="[weight]"]` to its
   * 0-based position in the current DOM order. Wrappers hidden by
   * nested-form#remove (display: none with _destroy=1) are skipped so that
   * surviving items always get contiguous 0-based weights.
   *
   * Called automatically on SortableJS `onEnd`, and can be wired to
   * nested-form events via `data-action`.
   */
  renumber() {
    let weight = 0
    for (const wrapper of this.element.querySelectorAll('.nested-form-wrapper')) {
      if (wrapper.style.display === 'none') continue

      const input = wrapper.querySelector('input[name*="[weight]"]')
      if (input) input.value = weight
      weight++
    }
  }
}
